import { types } from '../types/typesGeneral';

const initialState = {
    info: {},
    detail: {
        id: null,
        nombre_comercial: null,
        id_moneda: null,
        id_tipo_documento: null,
        id_forma_pago: null,
        id_area_negocio: null,
        nombre_area: null,
        observaciones_ventas: null,
        observaciones_compras: null,
    },
    categories: [],
    services: [],
    unitList: [],
    executiveList: [],
    usuariosTarea: [],
    currencyList: [],
    categoriesGasto: [],
    servicesGasto: [],
    listaFormasPagos: [],
    listaFormasPagosVentas: [],
    listaTiposDocumentos: [],
    listaDeBancos: [],
    listaTiposDeCuenta: [],
    listaCtasBancarias: [],
    rules: [],
    unidadMedida: [],
    openProgress: false
}

export const generalReducer = (state = initialState, action) => {

    switch (action.type) {

        // get ajustes parametros generales
        case types.ajustesLoadDetail:
            return {
                ...state,
                detail: action.payload
            }

        // get info propietaria
        case types.getInfoPropietaria:
            return {
                ...state,
                info: action.payload
            }

        // general
        case types.generalGetCategories:
            return {
                ...state,
                categories: [...action.payload]
            }

        case types.generalGetServices:
            return {
                ...state,
                services: [...action.payload]
            }

        case types.generalGetUnidadMedida:
            return {
                ...state,
                unidadMedida: [...action.payload]
            }

        case types.generalGetCategoriesGasto:
            return {
                ...state,
                categoriesGasto: [...action.payload]
            }

        case types.generalGetServicesGasto:
            return {
                ...state,
                servicesGasto: [...action.payload]
            }

        case types.generalAddNewServices:
            return {
                ...state,
                services: [...state.services, action.payload]
            }

        case types.generalAddNewCategories:
            return {
                ...state,
                categories: [...state.categories, action.payload]
            }

        case types.generalAddNewServicesBuy:
            return {
                ...state,
                servicesGasto: [...state.services, action.payload]
            }

        case types.generalAddNewCategoriesBuy:
            return {
                ...state,
                categoriesGasto: [...state.categories, action.payload]
            }


        case types.generalGetUnits:
            return {
                ...state,
                unitList: [...action.payload]
            }

        case types.generalGetExecutives:
            return {
                ...state,
                executiveList: [...action.payload]
            }

        case types.generalGetUsuariosTarea:
            return {
                ...state,
                usuariosTarea: [...action.payload]
            }

        case types.generalGetCurrency:
            return {
                ...state,
                currencyList: [...action.payload]
            }

        case types.generalGetFormasPagos:
            return {
                ...state,
                listaFormasPagos: [...action.payload]
            }

        case types.generalGetFormasPagosVentas:
            return {
                ...state,
                listaFormasPagosVentas: [...action.payload]
            }

        case types.generalGetTiposDocumentos:
            return {
                ...state,
                listaTiposDocumentos: [...action.payload]
            }

        case types.generalGetListaBancos:
            return {
                ...state,
                listaDeBancos: [...action.payload]
            }

        case types.generalGetListaTiposCuenta:
            return {
                ...state,
                listaTiposDeCuenta: [...action.payload]
            }

        case types.generalGetListaCtasBancarias:
            return {
                ...state,
                listaCtasBancarias: [...action.payload]
            }

        case types.generalGetRules:
            return {
                ...state,
                rules: [...action.payload]
            }

        case types.generalSetOpenProgress:
            return {
                ...state,
                openProgress: action.payload
            }

        default:
            return state;
    }

}
